import { Component, ElementRef, ViewChild, OnInit, AfterViewInit } from '@angular/core';
import { PageBase, T4TurboOrderService } from 't4core';
import { T4DatatableWidget } from '../../../../t4common';
import * as moment from 'moment';

@Component({
    selector: 'InsuranceSetOff',
  templateUrl: './InsuranceSetOff.html',
})
export class InsuranceSetOffComponent extends PageBase {

  @ViewChild("tblRequests") private tblRequests: T4DatatableWidget;

  public fromDate: moment.Moment = moment('2023-01-01');
  public toDate: moment.Moment = moment('2024-01-01');

  constructor(public orderSvc: T4TurboOrderService, el: ElementRef) {
    super(el, "InsuranceSetOff");
  }

  public openRequest(id: string) {
    this.UI.openDialog("T4.Service.ServiceDialog", { data: { requestId: id } });
  }

  public selectAll() { this.tblRequests.data.data.map(x => { if (x.Finance.TotalValue > 0 && (!x.Repurchase || (x.Repurchase && x.IsRepurchased))) this.tblRequests.selectRow(x); }); }
  public deselectAll() { this.tblRequests.clearSelection(); }

  public async sendPreview() {
    var arr = [];

      this.tblRequests.selectedRows.map(x => arr.push(x.Id));
      await this.orderSvc.AssembleRequestsForPreview(arr);

      await this.UI.alert("TO.Insurance.SetOff.headSent", "Complete!", "TO.Insurance.SetOff.msgSent", "The data has been assembled and sent to your email.")
  }

  public async sendInvoiceSpecification() {
    var arr = [];
    var repurchaseNotCompleted = this.tblRequests.selectedRows.some(x => x.Repurchase && !x.IsRepurchased);

    if (repurchaseNotCompleted) {
      await this.UI.alert("TO.Insurance.SetOff.Invalid", "Invalid selection!", "TO.Insurance.SetOff.errormessage", "Some of the selected cases are not repurchased yet.")
    }
    else {
      this.tblRequests.selectedRows.map(x => arr.push(x.Id));
      await this.orderSvc.AssembleRequestsForInvoicing(arr);
      this.tblRequests.update();

      await this.UI.alert("TO.Insurance.SetOff.headSent", "Complete!", "TO.Insurance.SetOff.msgSent", "The data has been assembled and sent to your email.")
    }
  }

  public async forget() {

    if (await this.UI.confirm("TO.Insurance.SetOff.headConfirmForget", "Forget insurance cases?", "TO.Insurance.SetOff.msgConfirmForget", "Are you sure you do not want to invoice these?")) {
      var arr = [];
      this.tblRequests.selectedRows.map(x => arr.push(x.Id));
      await this.orderSvc.ForgetInsuranceCases(arr);

      this.tblRequests.update();

      await this.UI.alert("TO.Insurance.SetOff.headForgotten", "What insurance cases?", "TO.Insurance.SetOff.msgForgotten", "You talk about those insurance cases but my eyes cannot lay gaze on any?!")
    }
    
  }
}
